import { useLayout } from 'context'
import { NeedsClusterRemovedDetailsDto, NeedsToBeMovedToStagingDetailsDto, NeedsToBeMovedToStagingWarrantyCertPhotoDto, VehicleDto } from 'dtos'
import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import * as controllers from 'controllers'
import NeedsToBeMovedToStagingStepper from './NeedsToBeMovedToStagingStepper'
import Step1PrepVehicleForOutboundTrip from './Step1PrepVehicleForOutboundTrip'
import Step2WarrantyCertPhoto from './Step2WarrantyCertPhoto'
import Step3StagingReview from './Step3StagingReview'
import { ArrowBack } from '@mui/icons-material'
import { Grid, Card, CardContent, Typography, Button } from '@mui/material'
import { enqueueSnackbar } from 'notistack'
import VehicleNeedsToBeMovedToStagingHeroCard from './VehicleNeedsToBeMovedToStagingHeroCard'

export interface VehicleNeedsToBeMovedToStagingPhotoProps {
  warrantyCertPhoto: NeedsToBeMovedToStagingWarrantyCertPhotoDto
  setWarrantyCertPhoto: React.Dispatch<React.SetStateAction<NeedsToBeMovedToStagingWarrantyCertPhotoDto>>
}

export default function VehicleNeedsToBeMovedToStaging() {
  const { vehicleGuid } = useParams()
  const layout = useLayout()
  const navigate = useNavigate()

  const [initialValues, setInitialValues] = useState<NeedsToBeMovedToStagingDetailsDto>(new NeedsToBeMovedToStagingDetailsDto())

  const [activeStep, setActiveStep] = useState<number>(0)
  const [warrantyCertPhoto, setWarrantyCertPhoto] = useState<NeedsToBeMovedToStagingWarrantyCertPhotoDto>(new NeedsToBeMovedToStagingWarrantyCertPhotoDto())

  useEffect(() => {
    if (vehicleGuid) {
      layout.setIsLayoutLoading(true)
      controllers
        .getNeedsToBeMovedToStagingDetails(vehicleGuid)
        .then(response => {
          setInitialValues(response.value)
        })
        .finally(() => {
          layout.setIsLayoutLoading(false)
        })

      controllers.getNeedsToBeMovedToStagingWarrantyCertPhotoInformation(vehicleGuid).then(response => {
        setWarrantyCertPhoto(response.value)
      })
    }
  }, [vehicleGuid])

  const onBack = () => {
    setActiveStep(prev => Math.max(0, prev - 1))
  }

  const onNext = () => {
    setActiveStep(prev => Math.min(3, prev + 1))
  }

  return (
    <Grid container spacing={1} alignItems='center'>
      <Grid item xs={12}>
        <Card>
          <CardContent>
            <Grid container justifyContent='space-between'>
              <Grid item>
                <Typography fontWeight='bold' variant='h5' sx={{ pr: 1 }}>
                  Needs To Be Moved To Staging
                </Typography>
              </Grid>

              <Grid item xs={12} sm='auto' container spacing={2} alignItems='center' justifyContent='flex-end'>
                <Grid item>
                  <Button
                    onClick={() => {
                      navigate('/to-do-list')
                    }}
                    color='primary'
                    startIcon={<ArrowBack />}
                    variant='text'
                  >
                    BACK
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12}>
        <VehicleNeedsToBeMovedToStagingHeroCard vehicle={initialValues} />
      </Grid>

      {activeStep === 0 && (
        <Grid item xs={12}>
          <Step1PrepVehicleForOutboundTrip initialValues={initialValues} onNext={onNext} />
        </Grid>
      )}

      {activeStep === 1 && (
        <Grid item xs={12}>
          <Step2WarrantyCertPhoto
            onBack={onBack}
            onNext={onNext}
            needsToBeMovedToStagingDetails={initialValues}
            vehicleGuid={vehicleGuid}
            warrantyCertPhoto={warrantyCertPhoto}
            setWarrantyCertPhoto={setWarrantyCertPhoto}
          />
        </Grid>
      )}

      {activeStep === 2 && (
        <Grid item xs={12}>
          <Step3StagingReview
            onBack={onBack}
            onNext={() => {
              layout.setIsLayoutLoading(true)

              controllers
                .updateNeedsToBeMovedToStagingDetails(vehicleGuid!, initialValues)
                .then(response => {
                  enqueueSnackbar('Moved To Staging Process Completed Successfully!', { variant: 'success' })
                  // setInitialValues(response.value)
                  navigate('/to-do-list', { replace: true })
                })
                .finally(() => {
                  layout.setIsLayoutLoading(false)
                })
            }}
            vehicleNeedsToBeMovedToStagingDetails={initialValues}
            vehicleGuid={vehicleGuid}
            warrantyCertPhoto={warrantyCertPhoto}
            setWarrantyCertPhoto={setWarrantyCertPhoto}
          />
        </Grid>
      )}
    </Grid>
  )
}
